//* 정산 내역 페이지 전용 atom (미정산 + 정산완료)

import { atom } from 'recoil';

import { QueryStatus } from 'react-query';
import { recoilPersist } from 'recoil-persist';

import {
  AccountDateType,
  MonthlyAccountedResponse,
  NeedAccountResponse,
} from './needAccount.interface';

const { persistAtom } = recoilPersist({
  key: 'needAccount',
  storage: typeof window !== 'undefined' ? localStorage : undefined,
});

// ── 미정산 내역 (NeedAccount) ──

export const needAccountStatusAtom = atom<QueryStatus>({
  key: 'needAccountStatusAtom',
  default: 'idle',
});

export const needAccountDataAtom = atom<NeedAccountResponse | null>({
  key: 'needAccountDataAtom',
  default: null,
});

/** 판매일/발인일 기준 선택 (localStorage persist) */
export const needAccountDateTypeAtom = atom<AccountDateType>({
  key: 'needAccountDateTypeAtom',
  default: 'purchasedAt',
  effects_UNSTABLE: [persistAtom],
});

// ── 정산완료 내역 (MonthlyAccounted) ──

export const monthlyAccountedStatusAtom = atom<QueryStatus>({
  key: 'monthlyAccountedStatusAtom',
  default: 'idle',
});

export const monthlyAccountedDataAtom = atom<MonthlyAccountedResponse | null>({
  key: 'monthlyAccountedDataAtom',
  default: null,
});
